import { useLocation, Navigate, Outlet } from "react-router-dom";
import React from "react";

const AuthRoute = ({ allowedRoles }) => {
  const location = useLocation();

  // Get user safely
  const user = JSON.parse(localStorage.getItem("user"));
  const rights = user?.data?.urights || [];

  // Extract right ids
  const rightKeyArr = rights.map((r) => r.right_id);

  // 🔓 PUBLIC ROUTE (right_id = 0)
  if (allowedRoles?.includes(0)) {
    return <Outlet />;
  }

  // 🔐 PROTECTED ROUTE
  const hasPermission = allowedRoles.some((role) =>
    rightKeyArr.includes(role)
  );

  return hasPermission ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};

export default AuthRoute;
